export const MSW_PROTOCOL_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Medical Social Worker",
        reportsTo: "Clinical Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The medical social worker is responsible for the assessment and treatment of patients who require medical social work services. The medical social worker provides these services in the patient's home under the direction of the physician and in accordance with the physician's plan of care."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Assesses the psychosocial status of patients related to the patient's illness and environment and communicates findings to the registered nurse and other health team members.",
            "Carries out social evaluations and plans interventions based on evaluation findings.",
            "Provides information and referral services for Organizations' patients and families regarding practical and environmental needs.",
            "Provides information to patients and families on financial and community resources.",
            "Serves as a liaison between patients and families and community agencies.",
            "Maintains clinical records on all patients referred to social work.",
            "Participates in the development of the plan of care.",
            "Prepares clinical and progress notes.",
            "Participates in discharge planning.",
            "Participates in Organization Home Care Team Member meetings and Organization Inservice Education Program.",
            "Performs other duties as assigned."
        ]
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of a master's degree program in social work accredited by the Council on Social Work Education.",
            "Minimum of one year's experience in health care, preferably in home health.",
            "Current certification or license as required by state law.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
